import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../environments/enviornment';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    private router: Router
  ) {}

  setCanonicalURL(url?: string) {
    let link: HTMLLinkElement =
      this.doc.querySelector("link[rel='canonical']") ||
      this.doc.createElement('link');

    let canonicalUrl = url;

    if (!canonicalUrl) {
      const host = environment.host.endsWith('/') ? environment.host.slice(0, -1) : environment.host;
      const path = this.router.url.split('?')[0];
      canonicalUrl = host + path;
    }

    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);

    if (!this.doc.querySelector("link[rel='canonical']")) {
      this.doc.head.appendChild(link);
    }
  }

  removeCanonicalURL() {
    const link = this.doc.querySelector("link[rel='canonical']");
    if (link) {
      this.doc.head.removeChild(link);
    }
  }
}
